"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = getHeaders;
exports.getHeadersGetter = getHeadersGetter;
var _constants = require("../constants");
/**
 * @param appName Application name / logger key.
 * @returns Gets function returning requests headers.
 */
function getHeadersGetter(appName) {
  return headersParams => getHeaders(headersParams, appName);
}
function getHeaders(headersParams, appName) {
  const {
    currentLanguage,
    isAddingSpecialHeadersForbidden,
    isApplicationNameAdded,
    tenant
  } = headersParams;
  return {
    [_constants.ACCEPT_LANGUAGE]: currentLanguage,
    ...(!isAddingSpecialHeadersForbidden && {
      ...(tenant && {
        [_constants.TENANT_CONTEXT]: tenant
      }),
      ...(isApplicationNameAdded && {
        [_constants.CLIENT_APPLICATION]: appName
      })
    })
  };
}
